import React from 'react';
import { Link } from 'react-router-dom';

// SEO: About Us structured data
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Cab Experience",
  "url": "https://cabexperience.com",
  "logo": "https://cabexperience.com/assets/images/logo/logo.png",
  "description": "Premier car rental service in Rajkot offering airport transfers, wedding car rental, outstation trips, and city tours across Gujarat.",
  "foundingDate": "2008",
  "founder": {
    "@type": "Person",
    "name": "Cab Experience"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Rajkot",
    "addressLocality": "Rajkot",
    "addressRegion": "Gujarat",
    "postalCode": "360001",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-7801904444",
    "contactType": "customer service",
    "availableLanguage": ["English", "Hindi", "Gujarati"]
  },
  "sameAs": [
    "https://www.facebook.com/cabexperience",
    "https://www.instagram.com/cabexperience",
    "https://twitter.com/cabexperience"
  ]
};

const AboutUs = () => {
  return (
    <React.Fragment>
      {/* Page Title */}
      <section
        className="page-title"
        style={{
          backgroundImage: 'url("/assets/images/bg1.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '100px 0'
        }}
      >
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-inner">
                <h1 className="title" style={{ color: 'white', textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
                  About Cab Experience
                </h1>
                <div className="breadcrumb" style={{ color: 'white' }}>
                  <Link to="/">Home</Link> / <span>About Us</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Content */}
      <section style={{ padding: '80px 0' }}>
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <h2 className="title mb-20">About Cab Experience</h2>
                <p className="description mb-20">
                  Cab Experience is Rajkot's premier car rental service,
                  dedicated to providing premium vehicles and exceptional
                  service to clients across Gujarat. With over 15 years of
                  experience in the car rental industry, we have established
                  ourselves as the most trusted and reliable name in car
                  hire services.
                </p>
                <p className="description mb-20">
                  Our commitment is simple: to provide our clients with
                  well-maintained, comfortable, and luxurious vehicles at
                  affordable rates. Whether you need a car for a wedding,
                  outstation trip, corporate event, or airport transfer, we
                  have the perfect solution for you.
                </p>
                <div className="list-icon-check">
                  <ul>
                    <li>
                      <i className="icon-Vector-32"></i>
                      <p>Fleet of well-maintained premium vehicles</p>
                    </li>
                    <li>
                      <i className="icon-Vector-32"></i>
                      <p>24/7 customer support and service</p>
                    </li>
                    <li>
                      <i className="icon-Vector-32"></i>
                      <p>Professional and experienced drivers</p>
                    </li>
                    <li>
                      <i className="icon-Vector-32"></i>
                      <p>Affordable and transparent pricing</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="about-image">
                <img
                  src="/assets/images/video.jpg"
                  alt="Cab Experience Fleet"
                  style={{ width: '100%', borderRadius: '10px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Fleet Section - Enhanced Design */}
      <section style={{ padding: '80px 0', background: 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)' }}>
        <div className="themesflat-container">
          <div className="heading-section text-center mb-50">
            <span style={{ color: '#edb808', fontSize: '14px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', display: 'block', marginBottom: '10px' }}>
              Our Premium Collection
            </span>
            <h2 style={{ fontSize: '40px', fontWeight: '700', color: '#1a1a2e', marginBottom: '15px' }}>
              Our Fleet
            </h2>
            <p style={{ color: '#666', fontSize: '16px', maxWidth: '600px', margin: '0 auto', lineHeight: '1.7' }}>
              Choose from our diverse range of well-maintained premium vehicles for any occasion
            </p>
          </div>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px' }}>
            {[
              {
                name: 'Swift Dzire',
                type: 'Sedan',
                image: '/assets/img/car/dzire.png',
                features: ['4+1 Seating', 'Petrol/Diesel', 'Manual/Auto'],
                link: '/swift-dzire',
                badge: 'Popular'
              },
              {
                name: 'Maruti Ertiga',
                type: 'MUV',
                image: '/assets/img/car/ertiga.png',
                features: ['6+1 Seating', 'Petrol/CNG', 'Manual/Auto'],
                link: '/maruti-ertiga',
                badge: 'Family'
              },
              {
                name: 'Innova Crysta',
                type: 'MPV',
                image: '/assets/img/car/crysta.png',
                features: ['7+1 Seating', 'Diesel', 'Manual/Auto'],
                link: '/innova-crysta',
                badge: 'Premium'
              },
              {
                name: 'Force Urbania',
                type: 'Luxury Van',
                image: '/assets/img/car/arban.jpg',
                features: ['13+1 Seating', 'Diesel', 'Manual'],
                link: '/force-urbania',
                badge: 'Group'
              },
              {
                name: 'Tempo Traveller',
                type: 'Mini Bus',
                image: '/assets/img/car/traveller.png',
                features: ['17+1 Seating', 'Diesel', 'Manual'],
                link: '/tempo-traveller',
                badge: 'Group'
              },
              {
                name: '56-Seater Bus',
                type: 'Bus',
                image: '/assets/img/car/bus.png',
                features: ['56 Seating', 'Diesel', 'Manual'],
                link: '/bus-56seater',
                badge: 'Events'
              }
            ].map((car, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                position: 'relative'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.08)';
              }}
              >
                {car.badge && (
                  <div style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px',
                    background: '#edb808',
                    color: '#1a1a2e',
                    padding: '5px 15px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: '2'
                  }}>
                    {car.badge}
                  </div>
                )}
                <div style={{
                  background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                  padding: '30px',
                  textAlign: 'center',
                  minHeight: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img 
                    src={car.image} 
                    alt={car.name}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '120px',
                      objectFit: 'contain',
                      filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.3))'
                    }} 
                  />
                </div>
                <div style={{ padding: '25px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <span style={{ 
                      background: 'rgba(237, 184, 8, 0.1)', 
                      color: '#edb808',
                      padding: '5px 12px',
                      borderRadius: '5px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {car.type}
                    </span>
                  </div>
                  <h3 style={{ 
                    fontSize: '22px', 
                    fontWeight: '700', 
                    color: '#1a1a2e',
                    marginBottom: '15px'
                  }}>
                    {car.name}
                  </h3>
                  <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    flexWrap: 'wrap',
                    marginBottom: '20px'
                  }}>
                    {car.features.map((feature, i) => (
                      <span key={i} style={{
                        background: '#f8f9fa',
                        padding: '6px 12px',
                        borderRadius: '5px',
                        fontSize: '12px',
                        color: '#666'
                      }}>
                        {feature}
                      </span>
                    ))}
                  </div>
                  <Link 
                    to={car.link}
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #edb808 0%, #f5c518 100%)',
                      color: '#1a1a2e',
                      padding: '12px 20px',
                      borderRadius: '10px',
                      textDecoration: 'none',
                      fontWeight: '600',
                      fontSize: '14px',
                      transition: 'opacity 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '0.9'}
                    onMouseOut={(e) => e.target.style.opacity = '1'}
                  >
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <Link 
              to="/car-list"
              style={{
                display: 'inline-block',
                background: 'transparent',
                color: '#1a1a2e',
                padding: '15px 40px',
                borderRadius: '50px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '16px',
                border: '2px solid #1a1a2e',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#1a1a2e';
                e.target.style.color = 'white';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#1a1a2e';
              }}
            >
              View All Vehicles
            </Link>
          </div>
        </div>
      </section>
  
      {/* Why Choose Us */}
      <section style={{ padding: '80px 0 0 0' }}>
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading-section text-center mb-40">
                <h2 className="title">Why Choose Cab Experience?</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {[
              { title: 'Best Rates', desc: 'Competitive pricing without compromising on quality' },
              { title: '24/7 Support', desc: 'Round-the-clock customer support for your peace of mind' },
              { title: 'Professional Drivers', desc: 'Courteous and experienced drivers trained for your safety' },
              { title: 'Well Maintained', desc: 'All vehicles regularly serviced and maintained' }
            ].map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-12 mb-30">
                <div className="feature-box" style={{ padding: '30px', textAlign: 'center' }}>
                  <i className="icon-Vector-32" style={{ fontSize: '40px', color: '#d32f2f', marginBottom: '15px', display: 'block' }}></i>
                  <h4 className="mb-10">{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mobile Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          .page-title { padding: 60px 0 !important; }
          .page-title h1 { font-size: 32px !important; }
          .about-content { padding: 20px !important; }
          .about-content h2 { font-size: 26px !important; }
          .about-content p { font-size: 14px !important; }
          .about-image { margin-top: 30px !important; }
          .about-image img { border-radius: 10px !important; }
          .fleet-section { padding: 50px 0 !important; }
          .fleet-section h2 { font-size: 28px !important; }
          .fleet-card { padding: 20px !important; margin-bottom: 20px !important; }
          .fleet-card h3 { font-size: 20px !important; }
          .fleet-card p { font-size: 14px !important; }
          .widget-testimonial { padding: 50px 0 !important; }
          .testimonial-card { padding: 25px !important; }
          .testimonial-card p { font-size: 14px !important; }
          .cta-section { padding: 50px 0 !important; }
          .cta-section h2 { font-size: 28px !important; }
          .cta-section p { font-size: 14px !important; }
        }
        @media (max-width: 480px) {
          .page-title h1 { font-size: 26px !important; }
          .about-content h2 { font-size: 22px !important; }
          .fleet-section h2 { font-size: 24px !important; }
          .cta-section h2 { font-size: 24px !important; }
        }
      `}</style>
    </React.Fragment>
  );
};

export default AboutUs;
